import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { hamburgerButton, menuPrimary, overlay } from './elements.js'

/**
 * Toggle main hamburger menu
 *
 * @author     Mario Hoyos
 * @version    1.0.0
 * @since      2021.1
 */
export function toggleMenu(e) {
	const expanded =
		hamburgerButton.getAttribute('aria-expanded') === 'true' || false
	const menuState = menuPrimary.getAttribute('data-visible') === 'true' || false

	if (e.currentTarget === hamburgerButton || (e.keyCode === 27 && expanded)) {
		menuPrimary.setAttribute('data-visible', !menuState)
		hamburgerButton.setAttribute('aria-expanded', !expanded)

		if (expanded) {
			enableBodyScroll(menuPrimary)
		} else {
			disableBodyScroll(menuPrimary)
		}
	}
}
